/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataClipResponse } from "./DataClipResponse";
export const ListDataClipResponse = core.serialization.object({
    data: core.serialization.list(DataClipResponse),
});
